import service from "../utils/axios";

const login = (data) => {
  return service.post("/login", data);
};

// config 支持传入请求级配置（如 skipAuthRedirect），由调用方决定 40201 的处理方式
const getUserInfo = (config) => {
  return service.get("/user_info", config);
};

const logout = () => {
  return service.post("/logout");
};

// 获取登录配置
const getLoginConfig = (data) => {
  return service.get("/user/login/config", { params: data });
};

// 获取微信登录状态
const getWxLoginStatus = (data) => {
  return service.get("/user/login/wx/status", { params: data });
};

// 获取手机验证码
const getLoginCodeSend = (data) => {
  return service.post("/user/login/code/send", data);
};

// 微信绑定
const postLoginSmsBind = (data) => {
  return service.post("/user/login/sms/bind", data);
};

// 账号密码登录
const phonePassword = (data) => {
  const { captcha_id, username, password } = data
  return service.post(`/user/login/password?captcha_id=${captcha_id}`, {
    username,
    password
  });
};

// 手机号登录
const postLoginSms = (data) => {
  const { captcha_id, phone, code } = data
  return service.post(`/user/login/sms?captcha_id=${captcha_id}`, {
    phone,
    code
  });
};

// 获取图形验证码
const getLoginCaptcha = () => {
  return service.get("/user/login/captcha");
};

// 验证图形验证码
const getLoginCaptchaVerify = (data) => {
  return service.post("/user/login/captcha/verify", data);
};

// 验证图形验证码
const getLoginPwdReset = (data) => {
  const { username, pwd, pwd2, code, captcha_id } = data
  return service.post(`/user/login/pwd/reset?captcha_id=${captcha_id}`, {
    username,
    pwd,
    pwd2,
    code
  });
};

// 获取完整个人信息
const getUserCenterInfo = () => {
  return service.get("/user_center/info");
};

// 更新个人信息
const postUserInfo = (data) => {
  return service.post("/user_center/profile/update", data);
};

// 获取个人积分
const getUserScore = () => {
  return service.get("/user_center/score");
};

// 获取独立权限列表
const getUserRolesList = () => {
  return service.get("/user_center/roles");
};

// 获取个人积分列表
const getUserScoreRecords = (data) => {
  return service.get("/user_center/score/records", { params: data });
};

// 获取个人积分来源
const getUserScoreSource = () => {
  return service.get("/user_center/score/source");
};

// 刷新TOKEN
const refreshToken = () => {
  return service.post("/user_center/token/refresh");
};

// 设置/修改密码
const postPwdUpdate = (data) => {
  return service.post("/user_center/pwd/update", data);
};

// 发送验证码
const postOldCodeSend = (data) => {
  return service.post("/user_center/code/send", data);
};

// 校验验证码
const postCodeCheck = (data) => {
  return service.post("/user_center/code/check", data);
};

// 修改联系方式
const postContactChange = (data) => {
  return service.post("/user_center/contact/change", data);
};

// 微信解绑
const postWxUnbind = () => {
  return service.post("/user_center/wx/unbind");
}

// 获取微信绑定配置
const getWxBindConfig = () => {
  return service.get("/user_center/wx/bind/config");
}

// 获取微信绑定状态
const getWxBindStatus = (params) => {
  return service.get("/user_center/wx/bind/status", { ...params });
}

// 注销校验
const postDelVerify = (data) => {
  const { captcha_id, phone, code } = data
  return service.post(`/user_center/delete/verify?captcha_id=${captcha_id}`, {
    phone,
    code
  });
}

// 确认注销
const postDel = (data) => {
  return service.post("/user_center/delete", data);
}

// 获取邀请列表
const getInvites = (data) => {
  return service.get("/user_center/invites", { params: data });
}

export {
  login,
  getUserInfo,
  logout,
  getLoginConfig,
  getWxLoginStatus,
  getLoginCodeSend,
  postLoginSmsBind,
  phonePassword,
  getLoginCaptcha,
  getLoginCaptchaVerify,
  postLoginSms,
  getLoginPwdReset,
  getUserCenterInfo,
  getUserScore,
  getUserRolesList,
  getUserScoreRecords,
  getUserScoreSource,
  postUserInfo,
  refreshToken,
  postPwdUpdate,
  postOldCodeSend,
  postCodeCheck,
  postContactChange,
  postWxUnbind,
  getWxBindConfig,
  getWxBindStatus,
  postDelVerify,
  postDel,
  getInvites
};
